import type { RequiredFileModel, Stored, UUID } from "@overmap-ai/common"
import { BaseOfflineFileModelApiService } from "@overmap-ai/core"

import { AppSDK } from "../../sdk"
import type { RootState } from "../../store"
import { genericMemo } from "../../utils/optimization"
import { FileAttachmentThumbnail } from "../Thumbnails/FileAttachmentThumbnail"
import { ImageAttachmentThumbnail } from "../Thumbnails/ImageAttachmentThumbnail"
import { VideoAttachmentThumbnail } from "../Thumbnails/VideoAttachmentThumbnail"

interface AttachmentThumbnailListProps<TAttachment extends UUID<RequiredFileModel>> {
	attachments: Stored<TAttachment>[]
	service: BaseOfflineFileModelApiService<string, TAttachment, RootState, AppSDK>
}

export const AttachmentThumbnailList = genericMemo(function <TAttachment extends UUID<RequiredFileModel>>(
	props: AttachmentThumbnailListProps<TAttachment>,
) {
	const { attachments, service } = props

	return (
		<div className="flex w-full flex-wrap gap-2">
			{attachments.map((attachment) => {
				const { file_type } = attachment

				const isImageAttachment = !!(file_type && file_type.startsWith("image/"))
				const isVideoAttachment = !!(file_type && file_type.startsWith("video"))

				if (isImageAttachment) {
					return <ImageAttachmentThumbnail key={attachment.uuid} attachment={attachment} service={service} />
				}

				if (isVideoAttachment) {
					return <VideoAttachmentThumbnail key={attachment.uuid} attachment={attachment} service={service} />
				}

				return <FileAttachmentThumbnail key={attachment.uuid} attachment={attachment} service={service} />
			})}
		</div>
	)
})
